module.exports = __webpack_public_path__ + "img/seo_gchess_item06.f7f7e50.webp";